import introMobileFrameImage from '@features/campaigns/builder/assets/images/creative-preview-browser-frame-intro-mobile.png';
import mastheadAdaptiveFrameImage from '@features/campaigns/builder/assets/images/creative-preview-browser-frame-masthead-adaptive.png';
import mastheadFrameImage from '@features/campaigns/builder/assets/images/creative-preview-browser-frame-masthead.png';
import skinFrameImage from '@features/campaigns/builder/assets/images/creative-preview-browser-frame-skin.png';
import { HighImpactCreativeType, HighImpactCreativeTypes } from '@features/campaigns/shared/types/campaign.ts';

import styles from './PreviewHighImpactWrapper.module.scss';

interface HighImpactPreviewFrame {
  frameImageSrc: string;
  slotClassName: string;
  frameContainerClassName?: string;
}

export const HIGH_IMPACT_PREVIEW_FRAMES: Record<HighImpactCreativeType, HighImpactPreviewFrame> = {
  [HighImpactCreativeTypes.SKIN]: { frameImageSrc: skinFrameImage, slotClassName: styles.slotSkin },
  [HighImpactCreativeTypes.MASTHEAD]: { frameImageSrc: mastheadFrameImage, slotClassName: styles.slotMasthead },
  [HighImpactCreativeTypes.MASTHEAD_ADAPTIVE]: {
    frameImageSrc: mastheadAdaptiveFrameImage,
    slotClassName: styles.slotMastheadAdaptive,
    frameContainerClassName: styles.frameContainerPhone,
  },
  [HighImpactCreativeTypes.INTRO_MOBILE]: {
    frameImageSrc: introMobileFrameImage,
    slotClassName: styles.slotIntroMobile,
    frameContainerClassName: styles.frameContainerPhone,
  },
};
